import { render, staticRenderFns } from "./BtnLink.vue?vue&type=template&id=258a272c&scoped=true&"
import script from "./BtnLink.vue?vue&type=script&lang=js&"
export * from "./BtnLink.vue?vue&type=script&lang=js&"
import style0 from "./BtnLink.vue?vue&type=style&index=0&id=258a272c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258a272c",
  null
  
)

export default component.exports